"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchWindowScroll = exports.windowSagas = void 0;
var effects_1 = require("redux-saga/effects");
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BackCallSaga_1 = require("@/pages/common/sagas/BackCallSaga");
var delayedScrollSaga = function (pos) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(50)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onWindowScroll(pos))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var delayedResizeSaga = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(500)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onWindowResize())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Listen to window resize events with throttling
 */
var watchWindowResize = function () {
    var channel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (window) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowResizeListener)];
            case 1:
                channel = _a.sent();
                return [4 /*yield*/, effects_1.takeLatest(channel, delayedResizeSaga)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Return element scrollTop with throttling
 * @param targetElement HTMLElement you wish to set scrollTop listener
 */
var watchWindowScroll = function (targetElement) {
    var channel, task, pos;
    if (targetElement === void 0) { targetElement = null; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (window) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowScrollListener, targetElement)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                pos = _a.sent();
                if (!task) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.cancel(task)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, effects_1.fork(delayedScrollSaga, pos)];
            case 6:
                task = _a.sent();
                return [3 /*break*/, 2];
            case 7: return [2 /*return*/];
        }
    });
};
exports.watchWindowScroll = watchWindowScroll;
/**
 * Listen to native DomContentLoaded
 * and emit onDomLoaded event.
 * It will only trigger once
 */
var watchDomLoaded = function () {
    var channel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (document) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.domLoadedListener)];
            case 1:
                channel = _a.sent();
                return [4 /*yield*/, effects_1.take(channel)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onDomLoaded())];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Initialize search page javascript sliders
 * and notify everyone on completed
 */
var watchSliderInitedEvent = function () {
    var channel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (document) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.sliderInitedListener)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onSliderInited())];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
/**
 * All Sagas related to browser DOM events
 */
var windowSagas = {
    popStateQueueSagas: BackCallSaga_1.popStateQueueSagas,
    watchWindowResize: watchWindowResize,
    watchWindowScroll: watchWindowScroll,
    watchDomLoaded: watchDomLoaded,
    watchSliderInitedEvent: watchSliderInitedEvent,
};
exports.windowSagas = windowSagas;
